/* eslint-disable camelcase */
export default {
	requisition_number: 'requisition_number',
	group_merchant_number_name: 'group_merchant_number_name',
	channel: 'channel',
	merchant_number_subject: 'merchant_number_subject',
	applicant: 'applicant',
	department: 'department',
	business_scene: 'business_scene',
	date_of_application: 'date_of_application',
	inquire: 'inquire',
	reset: 'reset',
	export: 'export',
	transfer: 'transfer',
	transfer_instructions: 'transfer_instructions',
	forwarded_to: 'forwarded_to',
	please_select_the_sender: 'please_select_the_sender',
	pending_type: 'Pending type',
	done_type: 'Done type',
	please_select_pending_type: 'Please select pending type',
	please_select_done_type: 'Please select done type'
};
